// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-header-action-delete-log' )
export class AutomatorLogHeaderActionDeleteLog extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// The link to edit the recipe
	@property( { type: String, attribute: 'log-delete-url' } ) accessor logDeleteURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ escapeHTML( __( 'Delete this log entry', 'uncanny-automator' ) ) }</span>

				<uo-button
					slot="target"
					color="transparent"
					size="small"

					href="${ this.logDeleteURL }"

					confirmation-heading=${ escapeHTML( __( 'This action is irreversible', 'uncanny-automator' ) ) }
					confirmation-content=${ escapeHTML( __( 'Are you sure you want to delete this entry?', 'uncanny-automator' ) ) }
					confirmation-button-label=${ escapeHTML( _x( 'Confirm', 'Verb', 'uncanny-automator' ) ) }

					needs-confirmation
				>
					<uo-icon id="trash" size="16"></uo-icon>
				</uo-button>
			</uo-tooltip>
		`;
	}
}